import { Directive, ElementRef, HostListener, Input } from "@angular/core";

@Directive({
  selector: "img[appHideMissing]",
})
export class HideMissingDirective {

  @Input() appHideMissing: string = 'teama';

  constructor(private el: ElementRef) {}

  @HostListener("error")
  private onError() {
    if (["teama", "teamb"].includes(this.appHideMissing)) {
      this.el.nativeElement.src = `../../assets/img/Default_App_Logo-05.png`;
    } else {
      this.el.nativeElement.src = `../../assets/img/person-avatar.png`;
    }
    // this.el.nativeElement.style.display = "none";
  }
}
